import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ActiveHomePageCarouselType } from 'src/api/config/cms/getActiveHomePageCarousel';
import { ItemTypePromo } from './ItemTypePromo';
import { ItemTypeBetting } from './ItemTypeBetting';
import { ItemTypeBonusEngine } from 'src/domains/layouts/webview/components/homePageCarouselPromos/ItemTypeBonusEngine';

interface HomePageCarouselItemPropsType {
    promo: ActiveHomePageCarouselType;
}

export const HomePageCarouselItem = observer('HomePageCarouselItem', ({ promo }: HomePageCarouselItemPropsType) => {
    switch (promo.media_type) {
        case 'betting':
            return <ItemTypeBetting promo={promo} />;
        case 'bonus-engine':
            return <ItemTypeBonusEngine promo={promo} />;
        default:
            return <ItemTypePromo promo={promo} />;
    }
});
